import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import EmployeeLogin from '@/pages/EmployeeLogin';
import EmployeeAttendance from '@/pages/EmployeeAttendance';
import HRLogin from '@/pages/HRLogin';
import HRDashboard from '@/pages/HRDashboard';
import HRLocations from '@/pages/HRLocations';
import HREmployees from '@/pages/HREmployees';
import HRReports from '@/pages/HRReports';
import HRNotifications from '@/pages/HRNotifications';
import HRTracking from '@/pages/HRTracking';
import HRTrackingHistory from '@/pages/HRTrackingHistory';
import HRTrackingReports from '@/pages/HRTrackingReports';
import AppDownload from '@/pages/AppDownload';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/employee/login" replace />} />
          <Route path="/employee/login" element={<EmployeeLogin />} />
          <Route path="/employee/attendance" element={<EmployeeAttendance />} />
          <Route path="/hr/login" element={<HRLogin />} />
          <Route path="/hr/dashboard" element={<HRDashboard />} />
          <Route path="/hr/locations" element={<HRLocations />} />
          <Route path="/hr/employees" element={<HREmployees />} />
          <Route path="/hr/reports" element={<HRReports />} />
          <Route path="/hr/notifications" element={<HRNotifications />} />
          <Route path="/hr/tracking" element={<HRTracking />} />
          <Route path="/hr/tracking/history" element={<HRTrackingHistory />} />
          <Route path="/hr/tracking/reports" element={<HRTrackingReports />} />
          <Route path="/app/download" element={<AppDownload />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" expand={false} richColors />
    </div>
  );
}

export default App;